// Apertura della chiamata GPT-Live: messaggio di benvenuto oppure flusso
// iniziale, sempre una delle due (il saluto improvvisato dal gestore non è più
// un'opzione). Fuori dal componente per poterla testare.

export function initialOpening(conversationConfig) {
  return conversationConfig?.initialFlowId ? 'flow' : 'welcome';
}

export function openingMissing(behavior, welcomeMessage, initialFlowId) {
  if (behavior === 'flow') return !initialFlowId;
  return !String(welcomeMessage || '').trim();
}
